import { useContext, useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import CartContext from "../../context/cart";
import useCartRequestUpdateMutation from "../../hooks/mutations/useCartRequestUpdateMutation";
import { emailRegex, getSameEmailRegex } from "../../utils/regex";
import Question from "../question";

const CartSelectionSummary = ({ tempCartId, setTempCartId }) => {
  const { survey, labels, campaign, formData, partial, cartRequest, appLang } =
    useContext(CartContext);
  const {
    register,
    handleSubmit,
    control,
    reset,
    watch,
    trigger,
    formState: { errors, touchedFields, dirtyFields },
  } = useForm({
    mode: "onTouched",
    defaultValues: useMemo(() => formData, [formData]),
  });

  const formWatch = watch();

  useEffect(() => reset(formData), [reset, formData]);

  const section = useMemo(() => survey?.definition?.sections?.[1], [survey]);

  const { mutateAsync: updateCartRequest, isLoading } = useCartRequestUpdateMutation();

  const onSubmit = async (values) => {
    if (isLoading) {
      return;
    }
    const body = {
      campaignId: campaign?.id,
      cartRequest,
      survey,
      formData,
      values,
      email: values[section.questions[0].id],
      partial,
      confirmationStep: true,
    };

    if (tempCartId !== undefined) {
      body.cartRequest = { ...cartRequest, contentId: tempCartId };
    }
    await updateCartRequest(body);
    setTempCartId(undefined);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="form" key={section.id} noValidate>
        {section?.questions?.map((question, i) => (
          <Question
            question={question}
            key={question.id}
            register={register}
            error={errors[`${question.id}`]}
            touched={touchedFields[`${question.id}`]}
            isDirty={dirtyFields[`${question.id}`]}
            control={control}
            trigger={trigger}
            labels={labels}
            pattern={
              i === 0
                ? emailRegex
                : i === 1
                ? getSameEmailRegex(formWatch[section.questions[0].id])
                : null
            }
            customPatternErrorMsg={
              i === 0
                ? labels?.WELFARE_NOT_VALID_EMAIL || "The inserted email is not valid"
                : i === 1
                ? labels?.WELFARE_NOT_CORRESPONDING_EMAIL ||
                  "The inserted email does not correspond"
                : null
            }
            attachments={survey?.attachments}
            locale={appLang?.value}
            trim={i < 2}
          />
        ))}
        <div className="form__buttons-wrapper">
          <div className="form__buttons form__buttons--center">
            <button className="button primary form__submit">
              {labels?.WELFARE_FORM_BTN_CONFIRM || "Confirm"}
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default CartSelectionSummary;
